import { useState, useEffect } from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      // 替换成你的 Workers URL
      const response = await fetch('https://curly-band-6b98.klierbyck.workers.dev/');
      if (!response.ok) {
        throw new Error('网络响应失败');
      }
      const jsonData = await response.json();
      
      // jsonData 格式应该是：
      // {
      //   message: "Hello World",
      //   status: "success",
      //   timestamp: "2024-01-18T12:34:56.789Z"
      // }
      
      setData(jsonData);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        
        {loading && <p>加载中...</p>}
        
        {error && <p>错误: {error}</p>}
        
        {data && (
          <div>
            <p>消息: {data.message}</p>
            <p>状态: {data.status}</p>
            <p>时间: {new Date(data.timestamp).toLocaleString()}</p>
          </div>
        )}

        <button 
          onClick={fetchData} 
          className="App-link"
          style={{ margin: '20px', cursor: 'pointer' }}
        >
          刷新数据
        </button>
      </header>
    </div>
  );
}

export default App;